import { Box,Flex } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import "@livekit/components-styles";
import {
  ControlBar,
  GridLayout,
  LiveKitRoom,
  ParticipantTile,
  RoomAudioRenderer,
  VideoConference,
} from "@livekit/components-react";
import Chat from "../components/livekit/host-chat";
import ChannelInfo from "../components/livekit/channel-info";
import StreamPlayer from "../components/livekit/stream-player";
import WatchingAsBar from "../components/livekit/watching-as-bar";

function Watch() {
  let { id } = useParams();
  const serverUrl = "wss://pindodg-g5szeweq.livekit.cloud";
  const token =
    "eyJhbGciOiJIUzI1NiJ9.eyJ2aWRlbyI6eyJyb29tIjoibWVldHVwIiwicm9vbUpvaW4iOnRydWUsImNhblB1Ymxpc2giOmZhbHNlLCJjYW5QdWJsaXNoRGF0YSI6dHJ1ZX0sImlzcyI6IkFQSUpOb1dHdEIyeVhnQSIsImV4cCI6MTcwOTYxNDI5MSwibmJmIjowLCJzdWIiOiJsdWNreSBndXkifQ.SU4seO8KQOMQ8idHDpF-2wJeiTZnIMFYjipRgeaQ6As";
  return (
    <Box backgroundColor={'white'} h={"100vh"} overflowY={"hidden"}>
    

      
      <LiveKitRoom
      
        token={token}
        serverUrl={serverUrl}
        // Use the default LiveKit theme for nice styles.
        data-lk-theme="default"
        style={{ height: "100vh" }}
      >
        <Flex>

       
          <Box style={{ height: "100vh" }} >
          <StreamPlayer streamerIdentity={'meetup'} />
         {/* <ChannelInfo streamerIdentity={'meetup'} viewerIdentity={'lucky guy'} /> */}
          </Box>
          <Box>
          <Chat participantName={'lucky guy'} />
          </Box>
          </Flex>
  
              {/* <WatchingAsBar viewerName={'lucky guy'} />
      <div className="flex h-full flex-1">
        <div className="flex-1 flex-col container">
          <StreamPlayer streamerIdentity={'meetup'} />
          <ChannelInfo streamerIdentity={'meetup'} viewerIdentity={'lucky guy'} />
          <div  className="sm:flex md:hidden sticky  w-80 border-l md:block ">
          <Chat participantName={'lucky guy'} />
          </div>
        </div>
        <div className="sticky hidden w-80 border-l md:block">
          <div className="absolute top-0 bottom-0 right-0 flex h-full w-full flex-col gap-2 p-2">
            <Chat participantName={'lucky guy'} />
          </div>
        </div>
      </div> */}
      
  
      </LiveKitRoom>
    </Box>
  );
}

export default Watch;
